import { jsxs as r, jsx as t, Fragment as u } from "react/jsx-runtime";
import { useTranslation as x, cents as _, FieldLabel as c, centsToUnits as g } from "@systemeio/ui";
import { twJoin as b } from "tailwind-merge";
import { CurrencyBadge as y } from "../../../../../ui-kit/currency-badge.mjs";
import { getAmountWithCurrencySymbol as S } from "../../../../../utils/get-amount-with-currency-symbol.mjs";
import { useLocaleContext as w } from "../../../../../providers/use-locale-provider.mjs";
import { usePhysicalProductStore as N, useOfferStore as T } from "../../../../../store/index.mjs";
import { calculateShippingTotal as v } from "../../utils/calculate-shipping.mjs";
import { Product as j } from "./product.mjs";
import { ShippingSummary as A } from "./shipping-summary.mjs";
const k = ({ product: n, calculatePrice: e, isLoading: m }) => {
  const { t: s } = x(), { locale: l } = w(), { selectedShipping: i } = N(), { finalAmount: f } = T(), o = !!i, a = !!(e != null && e.tax) && e.tax.rate > 0, h = o ? v(i, (e == null ? void 0 : e.tax.rate) ?? 0) : 0, p = _(Math.ceil(f ?? 0) + h), d = () => s(!a && !o ? "public_pages_purchase.total" : a && !o ? "public_pages_purchase.total_amount_with_tax" : !a && o ? "public_pages_purchase.total_amount_with_shipping" : "public_pages_purchase.total_amount_with_tax_and_shipping");
  return /* @__PURE__ */ r("div", { className: b("flex flex-col gap-1", m && "animate-pulse"), children: [
    /* @__PURE__ */ t(c, { label: s("public_pages_purchase.order_summary") }),
    /* @__PURE__ */ r("div", { className: "border-text-secondary/30 flex flex-col gap-5 rounded-lg border px-3.5 py-5", children: [
      /* @__PURE__ */ t(j, { product: n, calculatePrice: e }),
      o && /* @__PURE__ */ t(
        A,
        {
          product: n,
          selectedShipping: i,
          calculatePrice: e
        }
      ),
      p > 0 && /* @__PURE__ */ r(u, { children: [
        /* @__PURE__ */ t("div", { className: "bg-text-secondary/30 h-[1px] w-full" }),
        /* @__PURE__ */ r("div", { className: "flex w-full items-center justify-between", children: [
          /* @__PURE__ */ t("span", { className: "text-[14px] font-semibold", children: d() }),
          /* @__PURE__ */ r("div", { className: "flex items-center gap-2.5", children: [
            /* @__PURE__ */ t(y, { currency: n.currency }),
            /* @__PURE__ */ t("span", { className: "text-[14px] font-semibold", children: S(
              g(p),
              n.currency,
              l
            ) })
          ] })
        ] })
      ] })
    ] })
  ] });
};
export {
  k as OrderSummary
};
